module.exports = __webpack_public_path__ + "static/img/user-dark.e0c4d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v3/img/icons/user-dark.png
// module id = wQjk
// module chunks = 10